import { Component, ElementRef, ViewChild } from '@angular/core';
import entities from '../../misc/data/entities.json';
import data_items from '../../misc/data/data.json';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { data_item } from 'src/app/misc/interface/data';
import { DataService } from 'src/app/services/data.service';
import { CategoryStateService } from 'src/app/services/category-state.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { DataViewComponent } from './data-view/data-view.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent {
  @ViewChild('dataSection')
  dataSectionRef?: ElementRef;
  searchText = '';
  colors = ['#300a3b', '#2a0450', '#082f4e', '#011941', '#110d49'];

  recentsearches = [
    'الجهات المشاركة',
    'قوائم',
    'إصدار سجل تجاري',
    'اصدار سجل',
    'تحويل',
    'تأسيس',
    'شطب',
    'تعديل',
    'تعديل سجل تجاري',
  ];

  data_items: data_item[] = [];
  searchbarSearchValue: string = '';
  catdata: any;
  ous: OrganizationUnit[] | undefined;
  allCategories: any[] = [];
  fromSearch: boolean = false;
  editPermissionOUS: any;
  editPermission: boolean = false;
  filtersLoaded: boolean = false;
  currentDataItem: any;
  resetCurrentView: boolean = false;


  resetCurrentViewState(state: boolean) {
    this.resetCurrentView = state;
  }

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private stateHandler: CategoryStateService,
    private permissionService: PermissionHandlerService,
    private ouService: OrgUnitsService
  ) {
    this.route.params.subscribe(p => {
      let _id = p['id'];
      let keyword = p['searchquery'];
      this.keyword = keyword
      this.category_id = _id
      console.log('ID: ', _id, keyword);
      if (this.stateHandler.catList.length > 0) {
        this.allCategories = this.stateHandler.catList;
      }
      if (!_id && keyword) {
        this.fromSearch = true;
        this.searchEntity(keyword);
      } else {
        this.getEntity(_id);
      }
    })
  }

  handleSearchbarValueChange(val: string) {
    this.searchbarSearchValue = val;
  }

  // to check either state is created or not
  serviceIDforStates: string | undefined = undefined
  changeCurrentDataItem(dataItem: any) {
    this.currentDataItem = dataItem;
    // create a state log if not created
    if (this.serviceIDforStates != dataItem._id) {
      this.serviceIDforStates = dataItem._id
      this.createStates(dataItem)
    }


  }

  async createStates(data: any) {
    try {
      let uid = localStorage.getItem('uid');
      let user_name = localStorage.getItem('username')
      let payload = {
        user: {
          _id: uid,
          name: user_name
        },
        service_id: data._id,
        keyword: this.keyword,
        category_id: parseInt(this.category_id)
      }
      let res = await this.dataService.postData('states', payload)
      if (res.error) {
        console.warn("states log not created ...")
      }
    } catch (error) {
      console.log(error)
    }
  }

  //variables to create states
  keyword: any = null
  category_id: any = null


  ngOnInit() {

  }

  async checkEditPermission() {
    this.editPermission = await this.permissionService.checkOUPermission('CONTENT', 'u', this.catdata?.name);
    console.log('ALL OU', this.editPermission)
  }

  // {{item?.id}}
  async searchEntity(keyword: string) {
    try {
      let response = await this.dataService.postData('ou/getSearchedData', {
        keyword: keyword,
      });
      this.filtersLoaded = true;
      this.allCategories = response.data;
      this.stateHandler.catList = this.allCategories;
      if (this.allCategories) {
        this.catdata = this.allCategories[0];
      }
      console.log("SEARCH QUERY", this.catdata);
      this.extractDetails();
      this.dataSectionRef?.nativeElement.scrollIntoView();
    } catch (error) {
      this.filtersLoaded = true;
      console.log(error);
    }
  }

  async getEntity(id: number) {
    try {
      let response = await this.dataService.postData('ou/getwithgraph', {
        id: id,
      });
      this.filtersLoaded = true;
      console.log("ID QUERY", response.data);
      if (response.data) {
        this.catdata = response.data[0];
        this.extractDetails();
      }
      this.dataSectionRef?.nativeElement.scrollIntoView();
    } catch (error) {
      this.filtersLoaded = true;
      console.log(error);
    }
  }

  selectedCategoryChange(event: any) {
    console.log(event.name);
    this.catdata = event;
    this.extractDetails();
    this.router.navigate(['/category/', this.catdata.id]);
  }

  extractDetails() {
    if (this.catdata) {
      if (this.allCategories.length > 0) {
        this.ous = this.allCategories.filter((ou: OrganizationUnit) => ou._id != this.catdata._id && (ou.data_items && ou.data_items.length > 0))
      } else {
        this.ous = this.catdata.children?.filter(
          (x: OrganizationUnit) => x.score && x.score > 0
        );
        if (this.ous) {
          this.ous = this.fixOus(this.ous, this.catdata._id);
        }
      }
      this.catdata.parent = this.catdata.parents?.find(
        (x: OrganizationUnit) => x._id == this.catdata?.parent
      );

      if (this.catdata.parent) {
        this.catdata.parent.parent = this.catdata.parents?.find(
          (x: OrganizationUnit) => x._id == this.catdata?.parent?.parent
        );
      }

      if (this.catdata.parent?.parent) {
        this.catdata.parent.parent.parent = this.catdata.parents?.find(
          (x: OrganizationUnit) => x._id == this.catdata?.parent?.parent?.parent
        );
      }
    }

    console.log("SETTING CAT DATA", this.catdata);

    if (this.catdata && this.catdata.data_items) {
      this.data_items = this.catdata.data_items;
      this.data_items.sort((a, b) => {
        if (a.id > b.id) {
          return 1;
        } else if (a.id < b.id) {
          return -1;
        }
        return 0;
      })

    }
    this.checkEditPermission();
  }

  // async filterOUByPermission() {
  //  if (this.ous) {
  //   const treeData = await this.ouService.getOrgUnits();
  //   console.log('OU_NAME_T',treeData);
  //   this.ous = this.ous!.filter(e => {
  //     let ou = this.permissionService.extractOU('CONTENT', 'r');
  //     if (ou != null) {
  //       let ouChildren = this.ouService.extractOUChildren(treeData, ou.name);
  //       console.log("OU_NAME_R",ouChildren,ou.name);
  //       let result = this.ouService.childrenContains(ouChildren,e.name);
  //       console.log('OU_NAME_CONTAIN',result,e.name)
  //       return result;
  //     }
  //     return true;
  //   });
  //  }
  // }
  fixOus(ous: OrganizationUnit[], _id: any): OrganizationUnit[] {
    var rous: OrganizationUnit[] = [];

    ous.forEach((item: OrganizationUnit) => {
      if (item.parent == _id) {
        rous.push(item);
      }
    });

    return rous;
  }
}


